export const buttonTheme: {
  default: string;
  primary: string;
  lightBlue: string;
  lightGray: string;
  green: string;
  text: string;
  textRed: string;
  iconGray: string;
  redDanger: string;
  blueText: string;
} = {
  default: "default",
  primary: "primary",
  lightBlue: "lightBlue",
  lightGray: "lightGray",
  green: "green",
  text: "text",
  textRed: "textRed",
  iconGray: "iconGray",
  redDanger: "redDanger",
  blueText: "blueText",
};

export enum ButtonSize {
  small,
  medium,
  large,
}

export const getLeftNegativeClassName = (size: ButtonSize) => {
  if (size === ButtonSize.small) {
    return "-ml-0.5";
  }
  if (size === ButtonSize.large) {
    return "-ml-3";
  }
  return "-ml-2";
};
